import { z } from "zod";

export const MAX_FEEDBACK_COMMENT_LENGTH = 2000;

export const UpsertMessageFeedbackSchema = z.object({
  rating: z.enum(["POSITIVE", "NEGATIVE"]),
  comment: z
    .string()
    .trim()
    .max(MAX_FEEDBACK_COMMENT_LENGTH)
    .nullable()
    .optional()
});
